module.exports = __webpack_public_path__ + "img/badge.ea5c8c53.svg";